import { trackLanguageSwitch } from '../analytics/trackLanguageSwitch.js';

// Most of these are just capitalized, but we use a map for cases like Chinese (zh-CN)
const languageDisplayMap = {
  en: 'EN',
  es: 'ES',
  fr: 'FR',
  'zh-CN': 'ZH',
  tr: 'TR',
  ru: 'RU',
  ja: 'JA',
  vi: 'VI',
  pt: 'PT',
};

const updateLangLink = (link, closeFunc) => {
  const langCode = link.getAttribute('data-gt-lang');
  if (!languageDisplayMap[langCode] || link.dataset.iabbbLanguageLinkEnhanced === 'true') {
    return;
  }

  link.dataset.iabbbLanguageLinkEnhanced = 'true';

  const languageName = link.textContent;
  const languageCode = document.createElement('span');
  languageCode.className = 'language-list-code';
  languageCode.textContent = languageDisplayMap[langCode];

  link.replaceChildren(languageCode, languageName);

  //Analytic: header_language_switch
  link.addEventListener('click', () => {
    trackLanguageSwitch({ languageCode: langCode });
    closeFunc();
  });
};

export default updateLangLink;
